import API from "serviceshift-ui/api-client";

import { updateQueryParam } from "../../lib/url.js";

export default {
  createTask(_, { deptId, data }) {
    return API.tasks.create(deptId, { task: data });
  },
  deleteTask(_, { deptId, id }) {
    return API.tasks.delete(deptId, id);
  },
  fetchTask({ commit, dispatch }, { deptId, id }) {
    return API.tasks.get(deptId, id).then(async (res) => {
      commit("replace", {
        state: "currentTask",
        data: res.data
      });
      dispatch("updateTaskHistory", res.data);
      await updateQueryParam("task_id", res.data.id);
    });
  },
  fetchTasksTree({ commit }) {
    return API.tasks.fetchTaskTree().then((res) => {
      return commit("replace", {
        state: "tasksTree",
        data: res.data
      });
    });
  },
  updateTask({ commit }, { deptId, data }) {
    return API.tasks.update(deptId, data.id, { task: data }).then((res) => {
      commit("replace", {
        state: "currentTask",
        data: res.data
      });
    });
  },
  cloneTask({ commit }, { deptId, id }) {
    const url = `/v2/departments/${deptId}/tasks/${id}/clone_task`;
    return API.makeRequest(url, {
      method: "POST"
    }).then(async (res) => {
      commit("replace", {
        state: "currentTask",
        data: res.data
      });
      await updateQueryParam("task_id", res.data.id);
    });
  },
  fetchTaskCost({ commit }, { deptId, id }) {
    return API.axios
      .get(`/v2/departments/${deptId}/tasks/${id}/costs`)
      .then((res) => {
        commit("update", {
          state: "currentTask",
          data: { ...res.data }
        });
      });
  },
  clearCurrentTask({ commit }) {
    commit("replace", {
      state: "currentTask",
      data: null
    });
  },
  createTaskPart({ dispatch }, { deptId, id, data }) {
    return API.tasks.createPart(deptId, id, data).then(() => {
      return dispatch("fetchTask", {
        deptId,
        id
      });
    });
  },
  getTaskHistorySummary(_, link) {
    return API.makeRequest(link, {
      method: "GET"
    });
  },
  updateTaskPart({ dispatch }, { deptId, id, data }) {
    return API.tasks.updatePart(deptId, id, data).then(() => {
      return dispatch("fetchTask", {
        deptId,
        id
      });
    });
  },
  deleteTaskPart({ dispatch }, { deptId, id, partId }) {
    return API.tasks.deletePart(deptId, id, partId).then(() => {
      return dispatch("fetchTask", {
        deptId,
        id
      });
    });
  },
  setTaskTime({ commit }, { link, ...data }) {
    return API.makeRequest(link, {
      method: "PUT",
      data
    }).then((res) => {
      // Update task in store
      commit("replace", {
        state: "currentTask",
        data: res.data
      });
    });
  },
  async updateRecommendations({ dispatch }, taskData) {
    await API.tasks.updateRecommendations(taskData);
    dispatch("fetchTask", {
      deptId: taskData.deptId,
      id: taskData.id
    });
  },
  updateTaskHistory({ commit, state }, task) {
    // Prevent adding duplicates
    if (state.taskHistory.some((history) => history.id === task.id)) {
      return;
    }
    // Will clear history if not task is passed
    const taskHistory = task ? state.taskHistory.concat([task]) : [];
    commit("replace", {
      state: "taskHistory",
      data: taskHistory
    });
  }
};
